interface SectionTitleProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionTitle({ kicker, title, desc, align = "left" }: SectionTitleProps) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : "items-start"}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium tracking-wide text-primary-800">
        <i className="ri-bookmark-3-line text-sm" aria-hidden="true"></i>
        {kicker}
      </span>
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h2>
      {desc ? (
        <p className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? "mx-auto" : ""}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}